// Module
var code = "<reset-password></reset-password>\n";
// Exports
module.exports = code;